import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import BilateralLoanData from "../../../../components/bilateralLoanData";
import BilateralGuaranteeData from "../../../../components/bilateralGuaranteeData";
import LoadingOverlay from "react-loading-overlay";
import PropTypes from "prop-types";

const BilateralDetailLoan = ({...props}) => {
    return (
        <LoadingOverlay active={props.isLoading} spinner text='Cargando...'>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Bilaterales \ Tablero de Control \ Detalle"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Regresar"
                            style={{'float': 'right'}}
                            className="p-button-secondary"
                            onClick={props.handleReturnButton}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <BilateralLoanData
                        ref={props.bilateralLoanData}
                        selectedLoan={props.selectedLoan}
                        loading={props.loading}
                    />
                    <Grid item xs={12}>
                        <br/>
                        <Divider/>
                    </Grid>
                    <BilateralGuaranteeData
                        ref={props.bilateralCollateralData}
                        collateralDetail={props.collateralDetail}
                        loading={props.loading}
                    />
                    <Grid item xs={12}>
                        <br/>
                        <Divider/>
                    </Grid>
                </Grid>
            </Paper>
        </LoadingOverlay>
    )
};

export default BilateralDetailLoan;

BilateralDetailLoan.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    handleReturnButton: PropTypes.func.isRequired,
    selectedLoan: PropTypes.object.isRequired,
    collateralDetail: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    bilateralLoanData: PropTypes.object.isRequired,
    bilateralCollateralData: PropTypes.object.isRequired
};